<template>
  <infoBlock :title="$t('labels.contacts')" marker-color="#6FCF97">
    <template v-if="hasContacts()">
      <div v-for="(contact, index) in contacts" :key="index" class="profile-block__row">
        <div class="profile-block__row-label">{{contact.type}}</div>
        <div class="profile-block__row-data">{{contact.value}}</div>
      </div>
    </template>
    <template v-else>{{ $t('labels.not_specified') }}</template>
  </infoBlock>
</template>
<script>
  import infoBlock from 'src/components/InfoBlock/InfoBlock.vue'
  export default {
    props: [
      'contacts'
    ],
    components: {
      infoBlock
    },
    methods: {
      hasContacts () {
        let hasContacts = false;

        if (!this.contacts || typeof this.contacts !== 'object' || !Array.isArray(this.contacts)) {
          console.log('LOG: hasContacts -> Array.isArray(this.contacts)', Array.isArray(this.contacts))
          console.log('LOG: hasContacts -> typeof this.contacts', typeof this.contacts)
          console.log('LOG: hasContacts -> this.contacts', this.contacts)
          return;
        }

        if (this.contacts.another && this.contacts.another[0].name && this.contacts.another[0].value) {
          hasContacts = true
        }

        for (let contact in this.contacts) {
          if (this.contacts[contact]) {
            hasContacts = true
          }
        }
        return hasContacts;
      }
    }
  }
</script>
<style lang="scss">
.profile-contacts {
  &:before {
    background: #6FCF97;
  }
}
</style>